<template>
    <h4>DocumentDownload.vue</h4>

    <!-- ------- Select Document: -->
    <div class="flexRowNoWrapCenter" style="margin-top: 10px;">

        <div style="margin-right: 5px;">Select Document</div>

        <UploadAgentSimplified @proccessFiles="handle_proccessFiles">
        </UploadAgentSimplified>

    </div>

</template>
  
  <script>
import UploadAgentSimplified from "../../../components/dataSupport/UploadAgentSimplified.vue";

  export default {
    data() {return{
        uploadFileList: null,
        selectedFile: null,
        selectedSize: null,
        selectedFullString: null,
        fileItem: null,

    };},
    created() {
      console.log('SocumentDownload: **** created ****');
    },
    components: {UploadAgentSimplified},
    methods: {

    blobTest(){

    },

    handle_proccessFiles(filesToUpload) {

      // console.log("**** DocCmp: DocCmp.vue: handle_proccessFiles() ****");

      this.$data.uploadFileList = filesToUpload;

      console.log('--- DocCmp: handle_proccessFiles() ---');
      // this.log_fileFormData(filesToUpload);

      this.getFileInfoForDisplay(filesToUpload);

      console.log('111111111111111 DocCmp 22222222222222222');
      console.log('size = ', this.$data.fileItem.size);
      console.log('name = ', this.$data.fileItem.name);
      console.log('type = ', this.$data.fileItem.type);
      console.log('111111111111111 DocCmp 22222222222222222');

      this.downloadTheFile();
    },

    downloadTheFile() {
      var file = new Blob([this.$data.fileItem]);
      let fileURL = URL.createObjectURL(file)
      let link = document.createElement('a');
      link.href = fileURL;
      link.download = 'imageExample.png';
      // link.download = 'testingPDF.pdf';
      // link.download = 'sampleText.txt';
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    },

    getFileInfoForDisplay(filesToUpload) {
      filesToUpload.forEach((element) => {
        this.$data.fileItem = element;
        this.$data.selectedFile = this.$data.fileItem.name;
        this.$data.selectedSize = this.$data.fileItem.size;

        this.$data.selectedFullString = this.$data.fileItem.name + 
        '   (Size: ' + this.formatBytes(this.$data.fileItem.size) + ')';
      });
      console.log('-------->> DocumentDownload: getFileInfoForDisplay(): this.$data.selectedFile = ', 
      this.$data.selectedFile);
      console.log('DocumentDownload: getFileInfoForDisplay() -----------');
      console.log('size = ', this.$data.fileItem.size);
      console.log('name = ', this.$data.fileItem.name);
    },

    log_fileFormData(filesToUpload) {
      console.log('####################  DocCmp: log_fileFormData() 99 Start ####################');
      console.log('############## Input File Form Data ###############');
      console.log('filesToUpload = ', filesToUpload);
      filesToUpload.forEach((element) => {
        console.log('-----------');
        console.log('element.size = ', element.size);
        console.log('element.name = ', element.name);
      });
      console.log('############## 99 End ###############');
    },

    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    },


    // fileChangeEvent(fileInput) {

    //     console.log('##000');

    //     if (fileInput.target.files && fileInput.target.files[0]) {
    //         console.log('##aaa');

    //         const reader = new FileReader();
    //         reader.onload = (e) => {

    //         console.log('##bbb');
            
    //         // Create a Blog object for selected file & define MIME type
    //         var blob = new Blob(fileInput.target.files, { type: fileInput.target.files[0].type });

    //         console.log('##111');

    //         // Create Blog URL 
    //         var url = window.URL.createObjectURL(blob);

    //         var element = document.getElementById("selected-file");

    //         if (
    //             fileInput.target.files[0].type === 'image/png' ||
    //             fileInput.target.files[0].type === 'image/gif' ||
    //             fileInput.target.files[0].type === 'image/jpeg'
    //         ) {
    //             // View Image using Base64 String
    //             console.log(e.target.result);
    //             var img = document.createElement("img");
    //             img.src = e.target.result;
    //             element.appendChild(img);
    //         }

    //         // Create Blog View Link
    //         var a = document.createElement("a");
    //         var linkText = document.createTextNode("View File");
    //         a.target = "_blank";
    //         a.appendChild(linkText);
    //         a.href = url;
    //         element.appendChild(a);

    //         };
    //         reader.readAsDataURL(fileInput.target.files[0]);

    //     }
    // }
        
    },
  };
  </script>
  
  <style scoped>

.flexRowNoWrapCenter {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.itemCenterCenter {
  display: flex;
  align-items: center;
  justify-content: start;
}

  </style>
  